var map = {
	"./0100/16x9/10.jpg": "Q8WG",
	"./0100/21x9/10.jpg": "ulw2",
	"./0100/3x2/10.jpg": "tO4L",
	"./0100/4x1/10.jpg": "EeML",
	"./0100/4x3/10.jpg": "2c/x",
	"./0480/4x3/10.jpg": "Rhmk",
	"./0800/3x2/10.jpg": "xSkI",
	"./1200/16x9/10.jpg": "CSRT",
	"./1440/21x9/10.jpg": "Q+jn",
	"./1920/4x1/10.jpg": "ZnK5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UghV";